import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import {
  parseAnswers,
  normalizeRates,
  RecentRoundResultsSummary,
  ReadOnlyBetChoiceCardSP,
} from './PreBetRoundPreviewShared';

function PreBetRoundPreviewSP({ viewProps }) {
  const choices = useMemo(() => parseAnswers(viewProps?.round?.answers), [viewProps?.round?.answers]);
  const rates = useMemo(
    () => normalizeRates(viewProps?.roundRateData ?? viewProps?.round?.rates ?? viewProps?.round?.odds, choices),
    [choices, viewProps?.round?.odds, viewProps?.round?.rates, viewProps?.roundRateData],
  );

  return (
    <Box sx={{ display: 'grid', gap: 1.25, mb: 1.5 }}>
      <RecentRoundResultsSummary
        results={viewProps?.recentRoundResults}
        targetNumbers={viewProps?.recentRoundResultTargetNumbers}
        choices={choices}
        maxResults={7}
        rangeLabel="直近7ラウンド"
      />
      {choices.length >= 2 ? (
        <Box>
          <Box sx={{ mb: 0.75, fontSize: '12px', color: 'rgba(15, 23, 42, 0.72)', fontWeight: 900 }}>
            今回の選択肢
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 1 }}>
            {choices.map((choice, index) => (
              <ReadOnlyBetChoiceCardSP
                key={`${choice}-${index}`}
                choice={choice}
                index={index}
                rate={rates?.[index]}
              />
            ))}
          </Box>
        </Box>
      ) : null}
    </Box>
  );
}

export default PreBetRoundPreviewSP;
